import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppCommonModule } from '@app/modules/common/common.module';
import { TableModule } from '@app/modules/table/table.module';
import { PlatformModule } from '@app/platform.module';
import { PayrollForms } from './components';
import { OtherRemittancesDetailsComponent } from './components/other-remittances-details/other-remittances-details.component';
import { PaystubViewDetailsComponent } from './components/paystub-view-details/paystub-view-details.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        AppCommonModule,
        PlatformModule,
        TableModule,
        OtherRemittancesDetailsComponent,
        PaystubViewDetailsComponent,
    ],
    declarations: [...PayrollForms],
    exports: [...PayrollForms],
})
export class PayrollFormsModule {}
